export const getWidthViewport = () => {
    return window.innerWidth || document.body.clientWidth;
}
